import React from 'react';
import { Image } from 'antd';
import styled from 'styled-components';
import { ContentHeaderMain } from './ContentHeaderMain';

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 1;
    pointer-events: none;
  }
`;

const ImageStyled = styled(Image)`
  width: 100%;
  min-height: 600px;
  display: block;
  object-fit: cover;
  z-index: 0;

  @media (max-width: 768px) {
    min-height: 600px;
  }
`;

export const BlockHeader: React.FC = () => (
        <div style={{ position: 'relative' }}>
        <ImageWrapper>
            <ImageStyled src={'../img/resources.svg'} preview={false}/>
        </ImageWrapper>
            <ContentHeaderMain />
    </div>
);
